import { ShieldX } from "lucide-react";
import { useTranslation } from "react-i18next";
import { openSupportChat } from "@/lib/support";

/**
 * Экран заблокированного аккаунта.
 *
 * Полноэкранный и без кнопки «назад»: за ним нет состояния, в которое имело бы
 * смысл вернуться — сервер откажет любому запросу. Единственное осмысленное
 * действие отсюда — написать в поддержку, поэтому оно и стоит кнопкой.
 *
 * Причину блокировки не показываем. Её пишет оператор для себя и для разбора,
 * формулировки бывают внутренние («скам, чарджбэк по 8214»), а человеку на
 * экране нужен адрес, куда идти, а не наш комментарий о нём.
 */
const AccountBlockedScreen = ({ message }) => {
  const { t } = useTranslation();
  const telegram = typeof window !== "undefined" ? window?.Telegram?.WebApp : null;

  return (
    <div
      className="app-container flex items-center justify-center bg-background"
      data-testid="account-blocked-screen"
    >
      <div className="flex w-full max-w-sm flex-col items-center gap-4 px-8 text-center">
        <div className="flex h-16 w-16 items-center justify-center rounded-full bg-destructive/10 ring-1 ring-inset ring-destructive/35">
          <ShieldX className="h-7 w-7 text-destructive-fg" />
        </div>

        <h1 className="text-lg font-semibold text-foreground">{t("blocked.title")}</h1>
        {/* Текст сервера показываем, если он пришёл: там может стоять более
            точная формулировка, чем наша заготовка. */}
        <p className="text-sm leading-relaxed text-muted-foreground">
          {message || t("blocked.text")}
        </p>

        <button
          type="button"
          onClick={() => openSupportChat(telegram)}
          className="mt-2 w-full rounded-xl bg-primary px-4 py-3 text-sm font-semibold text-primary-foreground"
          data-testid="account-blocked-support"
        >
          {t("blocked.support_cta")}
        </button>
      </div>
    </div>
  );
};

export default AccountBlockedScreen;
